"use strict";

/*global  jQuery*/

jQuery(function ($) {
  "use strict";

  $('.logo01').delay(200).fadeIn(1200,function(){
    $('.logo01 .text').delay(1000).fadeOut(500);
    $('.logo02').delay(1200).fadeIn(700,function(){
      $('.logo02 .text').delay(1000).fadeOut(500);
      $('.logo03').delay(1200).fadeIn(700,function(){
        $('.logo03 .text').delay(1000).fadeOut(500);
        $('.logo04').delay(1200).fadeIn(700,function(){
          $('.logo04 .text').delay(1000).fadeOut(500);
          $('.logo05').delay(1200).fadeIn(700,function(){
            $('.logo05 .text').delay(1000).fadeOut(500);
              $('.logo06').delay(1200).fadeIn(700,function(){
              $('.bg-hero').fadeIn(2000);

            });
          });
        });
      });
    });
  });
  
  //スライドショー
  $('.top-slide_box').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    speed: 1000,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
  });
   /* 
  --------------------------------------
   モーダル
   colorbox
  --------------------------------------
  */
  $("a[rel='colorbox-group']").colorbox({
    iframe: false,
    inline: false,
    maxWidth: "80%",
    maxHeight: "80%",
    opacity: 0.7
  });
  $("a[href$='.jpg'],a[href$='.png'],a[href$='.jpeg']").colorbox({
    iframe: false,
    inline: false,
    maxWidth: "80%",
    maxHeight: "80%",
    opacity: 0.7
  });
  $("a.popup").colorbox({
    iframe: false,
    inline: true,
    maxWidth: "90%",
    maxHeight: "90%",
    opacity: 0.7
  });
    /*
  --------------------------------------
   スムーズスクロール
   #で始まるアンカーをクリックした場合に処理
   必要に応じて除外する要素を追記すること
  --------------------------------------
  */
  $(document).on('click', 'a[href*=\\#]:not([href=\\#],.popup)', function (event) {
      // アンカーの値取得
      var href = $(this).attr("href"),
      // 移動先を取得 velocity
      target = $(href === "#" || href === "" ? 'html' : href);
    // スムーススクロール
    target.velocity("scroll", 500);
    // 移動先を数値で取得 animate
//    target = $(href === "#" || href === "" ? 'html' : href),
//    position = target.offset().top;
    // スムーススクロール
//    $('body,html').animate({scrollTop: position}, speed, 'swing');
    return false;
  });
    /*
  --------------------------------------
   スクロール処理
   waypoint
  --------------------------------------
  */
  $(".demo-waypoint").waypoint(function () {
    $(".demo-waypoint").addClass("animated rubberBand");
  }, { offset: '20%' });
  
  $(".page-01").waypoint(function () {
    $(".page-01 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });

  $(".page-02").waypoint(function () {
    $(".page-02 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });

  $(".page-03").waypoint(function () {
    $(".page-03 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });
  
  $(".page-04").waypoint(function () {
    $(".page-04 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });
  
  $(".page-05").waypoint(function () {
    $(".page-05 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });
  
  $(".page-06").waypoint(function () {
    $(".page-06 .catch").addClass("animated fadeInRight");
  }, { offset: '0%' });
  
});